import { Header, Footer } from "../components/index.js";
import { Outlet } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import { useAppContext } from "../context/appContext/appContext.js";

const Main = () => {
  const { gameStarted } = useAppContext();

  return (
    <Flex direction="column" className="app-shell">
      {!gameStarted && <Header />}
      {/* A flex container, not a plain Box - a block div here would stop
          `flex="1"` on the page it renders (e.g. Play/PlayGame/Table)
          from having any effect, since that only works when the direct
          parent is itself a flex container. Still keeps the footer
          pinned to the bottom on short pages like Standings. */}
      <Flex flex="1" direction="column">
        <Outlet />
      </Flex>
      {!gameStarted && <Footer />}
    </Flex>
  );
};
export default Main;
